import {useContext, useEffect} from "react";
import { useParams } from "react-router";
import DevelopmentRequestController from "../../stories/_ticket/DevelopmentRequests/DevelopmentRequestController";
import AppContext from "../../context/AppContext";

const StateDevelopmentRequest = props => {
    const { state, subState, loadingText, loadingIcon, callbackSuccess } = props;
	const { setObjectPopup, setGetDatasPopup, setStatePopup, setSubStatePopup, setPopupLoadingText, setPopupLoadingIcon, setEvent } = useContext(AppContext);
	const params = useParams();

    const init = () =>  {
        setObjectPopup("developmentRequest");
        setStatePopup(state);

        if (loadingText !== undefined)
            setPopupLoadingText(loadingText);

        if (loadingIcon !== undefined)
            setPopupLoadingIcon(loadingIcon);

        switch (state) {
            case "loading":
                switch (subState) {
                    case "new":
						setTimeout(() => {
							setterNewDR();
						}, 300);

                        break;
                    case "update":
                        getDR();
                        break;
                    default: break;
                }

                break;
            default:
                break;
        }
    }
    const getDR = () => {
        const controller = new DevelopmentRequestController();
        controller._callback = returnGetDR;
        controller.show(params.id);
    }
    const returnGetDR = (object, error, status) => {
        switch (status) {
            case 200:
                setTimeout(() => {
                    setGetDatasPopup({
                        developmentRequest: object
                    });
                    setStatePopup("update");
                    setSubStatePopup(null);
                    setPopupLoadingText(null);
                    setPopupLoadingIcon(null);
                }, 300);

                break;
            default:
                setEvent({
					type: "error",
					text: "Une erreur s'est produite lors de l'ouverture de la demande d'évolution"
				});
                setStatePopup("hidden");
                setSubStatePopup(null);
                break;
        }
    }
    const setterNewDR = (datasPopup = null) => {
        setGetDatasPopup(datasPopup);
        setStatePopup("new");
        setSubStatePopup(null);
        setPopupLoadingText(null);
        setPopupLoadingIcon(null);
    }

    useEffect(() => {
        init();
    }, [state, subState, loadingText, loadingIcon, callbackSuccess]);
}

export default StateDevelopmentRequest;